import IconLeftArrowImport from 'components/Icons/IconLeftArrow/IconLeftArrow.svg?react';

export const IconLeftArrow = IconLeftArrowImport
